import React from 'react';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import ContactLink from 'common/components/contact-link';

import './error-page.scss';
import unexpectedError from './unexpected_error.png';

const messages = defineMessages({
  contactUsButton: {
    id: '',
    description: 'button text in error page, when clicked reroutes user to conact page',
    defaultMessage: 'Contact us',
  },
});

export type ErrorPageProps = {
  errorCode: string,
  errorTime: Date,
}
export function ErrorPage({ errorCode, errorTime }: ErrorPageProps) {
  const intl = useIntl();
  // The HTML and CSS for this component were extracted from
  // https://app.dev-hellosign.com/webapp_prod.php/account/logIn using this
  // script. (This is a permalink to the exact version I used)
  // https://gist.github.com/AsaAyers/d50940bea80c6e279171a622a27d682f/7c4717a758083c19b981cc16563d5570533a4b8e
  // That script did not handle `margin: 0 auto` correctly for divs 4, 9,
  // and 15, so it had to be adjusted manually.
  return (
    <div className="error-boundary">
      <div className="error-boundary__div1">
        <div className="error-boundary__div2">
          <div className="error-boundary__div3">
            <div className="error-boundary__div4">
              <div className="error-boundary__div5">&nbsp;</div>
              <div className="error-boundary__div6">
                <img className="error-boundary__image" src={unexpectedError} />
              </div>
              <div className="error-boundary__div7">&nbsp;</div>
            </div>
          </div>
          <div className="error-boundary__div8">
            <div className="error-boundary__div9">
              <div className="error-boundary__div10">
                <h2 className="error-boundary__h21">
                  <FormattedMessage
                    id=""
                    description="unknown error, message in error page"
                    defaultMessage="Looks like an unexpected error has occurred.{br}Sorry about that."
                    values={{
                      br: <br className="error-boundary__br1" />,
                    }} />
                </h2>

                <p className="error-boundary__p1">
                  <FormattedMessage
                    id=""
                    description="error message in error page, informing user that HelloSign Dev team has been notified about the issue"
                    defaultMessage="Our development team has been notified. Please try once
                        more. If the error persists, email us with the error code
                        and time below:" />
                </p>

                <div className="error-boundary__div11">
                  <p className="error-boundary__p2">
                    <FormattedMessage
                      id=""
                      description="unknown error, message in error page"
                      defaultMessage="Error code: {errorCode}"
                      values={{
                        errorCode: <strong className="error-boundary__strong1">{errorCode}</strong>,
                      }} />
                  </p>

                  <p className="error-boundary__p3">
                    <FormattedMessage
                      id=""
                      description="unknown error, message in error page, errorTime is simple time"
                      defaultMessage="Error time: {errorTime}"
                      values={{
                        errorTime: <strong className="error-boundary__strong2">{String(errorTime.toUTCString())}</strong>,
                      }} />
                  </p>
                </div>
              </div>
              <div className="error-boundary__div12">
                <div id="contact-us" className="error-boundary__contact-us">
                  <ContactLink
                    contactText={intl.formatMessage(messages.contactUsButton)} />
                </div>
              </div>
            </div>
          </div>
          {window.top === window && (
            <div className="error-boundary__div14">
              <div className="error-boundary__div15">
                <div className="error-boundary__div16">
                  <a href="/" className="error-boundary__links">
                    <FormattedMessage
                      id=""
                      description="link text in error page, when clicked redirects to home page"
                      defaultMessage="Home" />
                  </a> |
                  <a href="/account/logIn" className="error-boundary__links">
                    <FormattedMessage
                      id=""
                      description="link text in error page, when clicked redirects to login page"
                      defaultMessage="Login" />
                  </a> |
                  <a href="/account/signUp" className="error-boundary__links">
                    <FormattedMessage
                      id=""
                      description="link text in error page, when clicked redirects to sign up page"
                      defaultMessage="Sign Up" />
                  </a> |
                  <a href="/info/pricing" className="error-boundary__links">
                    <FormattedMessage
                      id=""
                      description="link text in error page, when clicked redirects to pricing page"
                      defaultMessage="Pricing" />
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );


}
